<section class="panel" aria-label="Statut global">
  <p class="bar">Statut global</p>
  <p class="status" [class.status--done]="done()">{{ status() }}</p>
  <div class="panel__text"><ng-content /></div>
  <div class="counters">
    @if (lobby()) {
      <div class="counter">
        <p class="bar bar--center">Agents recrutés</p>
        <p class="counter__value">
          <img src="/assets/silhouette.svg" alt="" />{{ digits(counts().total) }}
        </p>
        <p class="counter__caption">Prêts pour la mission</p>
      </div>
    } @else {
      <div class="counter">
        <p class="bar bar--center">Agents en lice</p>
        <p class="counter__value">
          <img src="/assets/silhouette.svg" alt="" />{{ digits(counts().inGame) }}
        </p>
        <p class="counter__caption">Agents toujours actifs</p>
      </div>
      <div class="counter">
        <p class="bar bar--center">Agents éliminés</p>
        <p class="counter__value">
          <img src="/assets/silhouette-out.svg" alt="" />{{ digits(counts().out) }}
        </p>
        <p class="counter__caption">Éliminés ou partis</p>
      </div>
    }
  </div>
</section>
